import React from "react";

import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import Box from "@mui/joy/Box";
import {CardOverflow, Stack} from "@mui/joy";
import Link from "@mui/joy/Link";
import CardContent from "@mui/joy/CardContent";
import Chip from "@mui/joy/Chip";

// components
import BaseApi from "../../utils/BaseApi";
import {
    replaceContentOptimized,
} from "./utils/replaceContentOptimized";

// icons
import CloseIcon from '@mui/icons-material/Close';


class CommentReplyCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            comment: null,
        };
    }

    async componentDidMount() {
        await this.retrieveComment()
    }

    async retrieveComment() {
        const url = `comment/${this.props.comment}/`;
        const params = {};
        const api = new BaseApi();
        let response = await api.get(url, params);
        let comment = response.data;
        comment.original_content = comment.content;
        comment.content = await replaceContentOptimized(comment.content);

        this.setState({
            comment: comment,
        });
    }

    switchOpen(){
        this.setState(
            {open: !this.state.open}
        )
    }

    render() {
        if (!this.state.comment){
            return null
        }
        return (
            <Card
                size="sm"
                variant={'outlined'}
                orientation="horizontal"

            >
                <CardOverflow
                    variant='soft'
                    color={'primary'}
                    sx={{
                        px: 0.1,
                        writingMode: 'vertical-rl',
                        textAlign: 'center',
                        borderLeft: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography
                        sx={{
                            transform: 'rotate(180deg)',
                            fontSize: '10px',
                            fontWeight: 'xl',
                            letterSpacing: '1px',
                            textTransform: 'uppercase',
                        }}
                    >
                        в ответ на
                    </Typography>
                </CardOverflow>
                <CardContent>
                    <Stack>
                        {
                            this.props.deleteCallBack?
                                <CloseIcon
                                    fontSize={'small'}
                                    onClick={this.props.deleteCallBack}
                                />:
                                null
                        }
                        <Typography
                            level="body-sm"
                        >
                            <strong>
                                {this.state.comment.owner.first_name} {this.state.comment.owner.last_name}
                            </strong> от &nbsp;
                            {this.state.comment.created_on}
                            {
                                this.state.comment.xtype !== 'COMMON'?
                                    <Chip
                                        size={'sm'}
                                        color={'primary'}
                                        sx={{
                                            ml: 1
                                        }}
                                    >
                                        #{this.state.comment.xtype_human}
                                    </Chip>:
                                    null
                            }
                        </Typography>
                        <Box
                            sx={{
                                fontSize: 'var(0.8rem)',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                height: this.state.open?null:'46px',
                            }}
                        >
                            <div dangerouslySetInnerHTML={{__html: this.state.comment.content}} />
                        </Box>
                        {
                                !this.props.deleteCallBack?
                                    this.state.open?
                                        <Link
                                            onClick={this.switchOpen.bind(this)}
                                            level="body-sm"
                                        >
                                            Свернуть
                                        </Link>:
                                        <Link
                                            onClick={this.switchOpen.bind(this)}
                                            level="body-sm"
                                        >
                                            Смотреть полностью
                                        </Link>:
                                    null
                            }
                    </Stack>
                </CardContent>

            </Card>
        )
    }
}

export default CommentReplyCard
